<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" @click="$emit('closeModal')">
        <div class="row">
          <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
          <div class="col-xs-12 col-sm-12 col-md-10 col-lg-8">
            <div class="modal-container" @click.stop>
              <div class="modal-header row" style="justify-content: flex-end;">
                <!-- <div class="col-6">
                  <button type="button" class="btn btn-sm btn-outline-primary" @click="$emit('newUserBack')">< Back</button>
                </div> -->
                <div class="col">
                  <button
                    type="button"
                    class="close"
                    @click="$emit('closeModal')"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
              </div>

              <div class="modal-body">
                <h2 class="title">Print Purchase Order Sparepart</h2>
				<!-- {{data}} -->

                <div class="row mt-3 mb-3">
                  <div class="col-md-6">
                    <h5>Pilih Sparepart Yang Akan Di Pesan:</h5>
                    <div class="row pl-3 mb-3">
                      <div class="col">
                        <button
                          class="btn btn-success btn-sm"
                          @click="checkAll()"
                        >
                          Pilih Semua
                        </button>
                        <button
                          class="btn btn-outline-primary btn-sm ml-3"
                          @click="dataSelected.splice(0)"
                        >
                          Kosongkan
                        </button>
                      </div>
                    </div>

                    <div
                      v-for="(dat, index) in data.filter(
                        (x) =>
                          !x.is_supplied_by_insurance &&
                          x.supplier_price_id != null &&
                          !x.deleted_at
						  
                      )"
                      :key="index"
                    >
                      <!-- {{dat}} -->
                      <input
                        :disabled="dat.is_arrived == true"
                        type="checkbox"
                        :id="'selectSparepart' + index"
                        v-model="dataSelected"
                        :value="dat"
                        style="width: 50px"
                      />
                      <label :for="'selectBank' + index">
                        {{ dat.sparepart_name }}
                      </label>
                    </div>
                  </div>
                </div>

                <div style="border: 1px solid black">
                  <!-- PRINT WO START -->
                  <div id="printMe" class="pl-4 pr-4">
                    <print-header></print-header>

                    <h4 class="">
                      Purchase Order Sparepart
                      {{ workOrderDetail.work_order_id }}
                    </h4>
                    <!-- <hr> -->
                    <h6 class="mb-3 mt-3">
                      No Polisi Mobil : {{ workOrderDetail.nomor_polisi }}
                    </h6>
                    <h6 class="mb-3 mt-3">
                      Tipe Mobil : {{ workOrderDetail.car_name }}
                    </h6>
                    <table class="table text-center">
                      <thead>
                        <th>No.</th>
                        <th>Name Sparepart</th>
                        <th>Deskripsi Sparepart</th>
                        <th>Jumlah</th>
                        <th>Harga Sparepart</th>
						<th>Harga Estimasi</th>
                        <th>Supplier</th>

                        <th>Estimasi Datang</th>
                      </thead>
                      <tbody
                        v-for="(poData, index) in dataSelected"
                        :key="index"
                      >
                        <tr>
                          <td>{{ index + 1 }}</td>
                          <!-- <td>{{poData}}</td> -->
                          <td>{{ poData.sparepart_name }}</td>
                          <td>{{ poData.part_number }}</td>
                          <td>{{ poData.amount }}</td>
						  <td>
                            Rp
                            {{
                              numberWithCommas(
                                poData.amount *
                                  (parseFloat(poData.price_per_item))
                              )
                            }}
                          </td>
                          <td>
                            Rp
                            {{
                              numberWithCommas(
                                poData.amount *
                                  (parseFloat(poData.price_per_item) + parseFloat(poData.markup))
                              )
                            }}
                          </td>
                          <td>
                            {{
                              !poData.is_supplied_by_insurance
                                ? $store.getters.getSupplier.find(
                                    (x) => x.id == poData.supplier_id
                                  ).name
                                : "Asuransi"
                            }}
                          </td>
                          <td>
                            {{
                              !poData.is_supplied_by_insurance
                                ? moment()
                                    .businessAdd(parseInt(poData.inden))
                                    .format("DD MMM Y")
                                : momentInsurance().businessDiff(
                                    momentInsurance(poData.updated_at)
                                  ) + " Days"
                            }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <h5 class="mt-5">
                      Total Harga : Rp
                      {{
                        numberWithCommas(
                          sum(
                            dataSelected.map(
                              (x) => x.amount * (parseFloat(x.price_per_item))
                            )
                          )
                        )
                      }}
                    </h5>
                    <h5 class="mt-2">
                      ##{{
                        dataSelected.length > 0
                          ? sum(
                              dataSelected.map(
                                (x) => x.amount * (parseFloat(x.price_per_item))
                              )
                            ).toFixed(0)
                          : 0 | terbilang
                      }}##
                    </h5>
					<!-- <h6 class="mt-2">
                      {{
                        dataSelected.length > 0
                          ? sum(
                              dataSelected.map(
                                (x) => x.amount * (parseFloat(x.price_per_item))
                              )
                            ).toFixed(0)
                          : 0 | terbilang
                      }}
                    </h6> -->
                    <h6 class="mt-4">
                      Jakarta, {{ moment().format("DD MMMM Y") }}
                    </h6>

                    <div class="row ">
                      <div class="col-3 ">
                        <h6></h6>
                        <h6>Service Advisor</h6>

                        <hr style="margin-top:100px" />
                      </div>
                      <div class="col-3 offset-4 text-left">
                        <h6>Finance</h6>

                        <hr style="margin-top:100px" />
                      </div>
                    </div>
                  </div>
                  <!-- PRINT WO END -->
                </div>
                <div class="row mt-3">
                  <div class="col-12 text-center">
                    <button
                      class="btn btn-info mr-3"
                      style="width: 75px;"
                      @click="printPage"
                    >
                      Print
                    </button>
                    <button
                      class="btn btn-primary"
                      style="width: 75px;"
                      @click="$emit('closeModal')"
                    >
                      Kembali
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import printHeader from "@/components/print/print_header.vue";
import moment from "moment-business-days";
import momentInsurance from "moment-business-days";

momentInsurance.updateLocale("id", {
  workingWeekdays: [1, 2, 3, 4, 5],
});
moment.updateLocale("id", {
  workingWeekdays: [1, 2, 3, 4, 5, 6],
});

export default {
  data() {
    return {
      moment,
      momentInsurance,
      dataSelected: [],
    };
  },
  props: ["data", "workOrderDetail", "dataSupplierPriceList" , 'form_code'],
  components: {
    printHeader,
  },
  async mounted() {
    // this.printPage();
    // console.log('lala')
  },
  watch: {
    dataSelected: function() {
      for (var i = 0; i < this.dataSelected.length; i++) {
        let curData = this.dataSelected[i];

        if (!curData.supplier_id) {
          let supplierData = this.dataSupplierPriceList[curData.id]
            .supplier_prices;
          // console.log(supplierData, curData.supplier_price_id)

          curData.supplier_id = supplierData.find(
            (x) => x.id == curData.supplier_price_id
          ).supplier_id;
          curData.inden = supplierData.find(
            (x) => x.id == curData.supplier_price_id
          ).inden;
        }
      }
    },
  },
  methods: {
    checkAll() {
      let allowCheck = this.data.filter(
        (x) => !x.is_supplied_by_insurance && !x.deleted_at
      );
      this.$set(this, "dataSelected", []);

      for (var i = 0; i < allowCheck.length; i++) {
        let sparepart = allowCheck[i];
        let supplierData = this.dataSupplierPriceList[sparepart.id]
          .supplier_prices;

        let tempSupplier = supplierData.find(
          (x) => x.id == sparepart.supplier_price_id
        );
        if (!tempSupplier) continue;
        sparepart.supplier_id = tempSupplier.supplier_id;

        sparepart.inden = supplierData.find(
          (x) => x.id == sparepart.supplier_price_id
        ).inden;

        if (!sparepart.is_arrived) this.dataSelected.push(sparepart);
		console.log(sparepart)
      }
    },
    printPage() {
		
		

		// for(var i = 0 ; i < this.dataSelected.length ; i++) {
		// 	let curData = this.dataSelected[i];
		// 	console.log(curData)
		// 	if(curData.is_po) continue;

		// 	let data = {
		// 	    estimation_id: curData.id,
		// 	    sparepart_id: curData.sparepart_id,
		// 	    dp : 0
		// 	}

    

			// console.log(data)
      let data = this.dataSelected.filter(x => !x.is_po).map( x => {
        return {
          estimation_id : x.id,
          sparepart_id : x.sparepart_id,
          dp : 0
        }
      })

			this.$http.post('/api/v1/purchase-order/' + this.form_code, data)
			.then((resp) => {
			    // console.log(resp.data.data)
			    // this.getEstimationDetails()
				this.$store.dispatch('triggerAlert' , [true , 'Barang telah tercatat terpesan.'] )
        this.$htmlToPaper("printMe");
				this.$emit('loadEstimation');
				this.$emit('closeModal');
			})
			.catch((err) => {
			    console.log(err)
			})
		// }
		
    },
    sum(arr) {
      let total = 0;

      for (var i = 0; i < arr.length; i++) {
        total += arr[i];
      }
      return total;
    },
  },
};
</script>

<style scoped>
/* ==========================================================================
#FORM made by Colorlib (https://colorlib.com)
========================================================================== */
input {
  outline: none;
  margin: 0;
  border: none;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  width: 100%;
  font-size: 14px;
  font-family: inherit;
}

.input--style-4 {
  line-height: 50px;
  background: #fafafa;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  padding: 0 20px;
  font-size: 16px;
  color: #666;
  -webkit-transition: all 0.4s ease;
  -o-transition: all 0.4s ease;
  -moz-transition: all 0.4s ease;
  transition: all 0.4s ease;
}

.input--style-4::-webkit-input-placeholder {
  /* WebKit, Blink, Edge */
  color: #666;
}

.input--style-4:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #666;
  opacity: 1;
}

.input--style-4::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #666;
  opacity: 1;
}

.input--style-4:-ms-input-placeholder {
  /* Internet Explorer 10-11 */
  color: #666;
}

.input--style-4:-ms-input-placeholder {
  /* Microsoft Edge */
  color: #666;
}

.label {
  font-size: 16px;
  color: #555;
  text-transform: capitalize;
  display: block;
  margin-bottom: 5px;
}

.radio-container {
  display: inline-block;
  position: relative;
  padding-left: 30px;
  cursor: pointer;
  font-size: 16px;
  color: #666;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.radio-container input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

.radio-container input:checked ~ .checkmark {
  background-color: #e5e5e5;
}

.radio-container input:checked ~ .checkmark:after {
  display: block;
}

.radio-container .checkmark:after {
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  -moz-transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  -o-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  width: 12px;
  height: 12px;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  background: #57b846;
}

.checkmark {
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 0;
  height: 20px;
  width: 20px;
  background-color: #e5e5e5;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  -webkit-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  -moz-box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
  box-shadow: inset 0px 1px 3px 0px rgba(0, 0, 0, 0.08);
}

.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

.input-group {
  position: relative;
  /* margin-bottom: 22px; */
  padding: 20px;
}

.input-group-icon {
  position: relative;
}

.input-icon {
  position: absolute;
  font-size: 18px;
  color: #999;
  right: 18px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  -o-transform: translateY(-50%);
  transform: translateY(-50%);
  cursor: pointer;
}

/* ==========================================================================
    #TITLE made by Colorlib (https://colorlib.com)
    ========================================================================== */
.title {
  font-size: 40px;
  color: #525252;
  margin-bottom: 40px;
  text-align: center;
}

.companyDetails {
  margin-bottom: 5px;
  font-size: 0.6rem;
}
/* .documentTitle{
  font-size: 40px;
  border: 1px solid black;
  border-radius: 10px;
  padding:20px 30px;
} */
.contentTitle {
  margin-top: 8px;
  font-size: 14px;
  font-weight: 700;
}
.contentVariable {
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-size: 14px;
}
</style>
